import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fa37440"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h3 text-center" }, "Bestattungskosten-Konfigurator", -1))
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "row row--results no-gutters my-4" }
const _hoisted_4 = { class: "col-5 offset-1 p-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "d-block mb-2" }, "Ihre Auswahl", -1))
const _hoisted_6 = { class: "chosen-path-segments" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "col-5 p-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "d-block mb-2" }, "Gewählte Zusatzleistungen", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "chosen-additional-options" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "row my-4" }
const _hoisted_21 = { class: "col-6 mx-auto text-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Preisschätzung", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Für eine Bestattung mit den ausgewählten Optionen sollten Sie etwa diese Summe einplanen:", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("ca. ")
const _hoisted_25 = { class: "display-4" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Darin enthalten sind ")
const _hoisted_28 = { class: "cost-external" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" und ")
const _hoisted_30 = { class: "cost-internal" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bei der angegebenen Summe handelt es sich um eine erste Schätzung. Für ein ausführliches Angebot sprechen Sie uns gerne an! ", -1))
const _hoisted_32 = { class: "row row--footer" }
const _hoisted_33 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_summary_print_header = _resolveComponent("summary-print-header")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_summary_print_header, {
      "mortician-email": _ctx.morticianEmail,
      "mortician-name": _ctx.morticianName,
      "mortician-phone-number": _ctx.morticianPhoneNumber,
      class: "mb-4"
    }, null, 8, ["mortician-email", "mortician-name", "mortician-phone-number"]),
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, " Ihre Auswahl vom " + _toDisplayString(_ctx.currentLocalDate), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenSegmentsTitles, (segment) => {
            return (_openBlock(), _createElementBlock("li", {
              key: segment.alias
            }, [
              _createElementVNode("i", {
                class: "d-block",
                innerHTML: _ctx.decodeHtmlString(segment.title) + ' ' + _ctx.getSegmentPriceForDisplay(segment)
              }, null, 8, _hoisted_7),
              _hoisted_8,
              (segment.dataObject && segment.dataObject.packageDescription)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: _ctx.decodeHtmlString(segment.dataObject.packageDescription)
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        (_ctx.chosenAdditionalOptions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenAdditionalOptions, (option) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: option.id
                  }, [
                    _createElementVNode("span", {
                      class: "text-primary",
                      innerHTML: _ctx.decodeHtmlString(_ctx.getGroupTitleForOption(option))
                    }, null, 8, _hoisted_14),
                    _hoisted_15,
                    _createElementVNode("span", {
                      innerHTML: _ctx.decodeHtmlString(option.title)
                    }, null, 8, _hoisted_16),
                    _hoisted_17,
                    _createElementVNode("span", {
                      innerHTML: _ctx.decodeHtmlString(_ctx.getOptionPriceForDisplay(option.price))
                    }, null, 8, _hoisted_18)
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_19, " Keine Zusatzoptionen ausgewählt. "))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("p", null, [
          _hoisted_24,
          _createElementVNode("strong", _hoisted_25, _toDisplayString(_ctx.calculatedPriceForDisplay), 1)
        ]),
        (_ctx.calculatedExternalPricePartForDisplay !== '')
          ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.calculatedExternalPricePartForDisplay) + " Fremdkosten", 1),
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.calculatedInternalPricePartForDisplay) + " Eigenkosten.", 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_31
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      (!!_ctx.footerText)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "col-auto mx-auto",
            innerHTML: _ctx.decodeHtmlString(_ctx.footerText)
          }, null, 8, _hoisted_33))
        : _createCommentVNode("", true)
    ])
  ]))
}